/**
 * @author NikolaV
 */
import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Notify } from '../.././ui-native/Notify';
import { Dialog } from '../.././ui-react/Dialog';
import { ReactUtils } from '../../ui-react/ReactUtils';
import './PageStateShare.scss';
import { Button } from "@shared/ui-react/Button";
import { EmailPageStateDialog } from "@shared/user-state/ui/EmailPageStateDialog";

// declare var Clipboard: any;



export const PageStateShare = {
    open: (item: IPageState) => {
        ReactUtils.safeRender(<PageStateShareDialog item={item}/>, document.getElementById('react-portal-root'));
    },

    close: () => {
        ReactUtils.safeUnmountComponentAtNode(document.getElementById('react-portal-root'));
    },

    getUrls: (uuid: string) => {
        const urlRoot = location.origin + '/kuura/';
        const url2d = urlRoot + 'main.htm?state=' + uuid;
        const url3d = urlRoot + 'mapvisualization.htm?state=' + uuid;
        // const url3dNew = urlRoot + 'mapvisualization.htm?state=' + uuid;

        return {
            url2d,
            url3d,
            // url3dNew,
        };
    }
};

class PageStateShareDialog extends React.Component<{
    item: IPageState,
}> {
    render() {
        const { item } = this.props;
        const { url2d, url3d, /*url3dNew*/ } = PageStateShare.getUrls(this.props.item.uuid);

        return (
            <Dialog title={this.props.item ? this.props.item.name : ''}
                    onClose={PageStateShare.close}>

                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 100,
                    zIndex: 0,
                    opacity: 0.7,
                    filter: 'blur(2px)',
                    backgroundImage: 'linear-gradient(-45deg, #F5F6F7 250px, transparent), url("' + (item ? item.thumbnail : null) + '")',
                    backgroundSize: 'cover',
                }}/>

                <div id='dialog-share-state' style={{ padding: '5em' }}>
                    <div className='text-center desc'>{__('js_map.share_state_desc')}</div>
                    <hr/>
                    <div className='card'>
                        <div className='flex-row' style={{ alignItems: 'center', padding: '2em' }}>
                            <div>
                                {item.type === '2D' && <div className='btn-group' style={{ marginBottom: '0' }}>
                                    <h2>2D</h2>
                                    <URLClipboard url={url2d}/>
                                    <Button onClick={() => EmailPageStateDialog.open(url2d, this.props.item)}
                                            className="send-email-button"
                                            tooltip={__('js_files.email.send_email')}
                                            icon='iki iki-share'/>
                                </div>}

                                {item.type === '3D' && <div className='btn-group' style={{ marginBottom: '0' }}>
                                    <h2>3D</h2>
                                    <URLClipboard url={url3d}/>
                                    <Button onClick={() => EmailPageStateDialog.open(url3d, this.props.item)}
                                            className="send-email-button"
                                            tooltip={__('js_files.email.send_email')}
                                            icon='iki iki-share'/>
                                </div>}

                                {/*<div className='btn-group' style={{ marginBottom: '0' }}>
                                    <h2>3D New</h2>
                                    <URLClipboard url={url3dNew}/>
                                </div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}


function URLClipboard(props) {
    return <>
        <input type='text' value={props.url} readOnly/>

        <CopyToClipboard text={props.url} onCopy={() => Notify.success('Copied')}>
            <button>{__('js_map.copy_to_clipboard')}</button>
        </CopyToClipboard>
    </>;
}
